import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDefectTypeAvailableColumns, getCities, getDefectTypeCostList } from './api';

export const path = `/defect-type/list`;

const PageDefectTypeList: React.FC = (props) => {
  const DefectTypeList = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      cities: getCities,
      costs: getDefectTypeCostList,
      columns: getDefectTypeAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <DefectTypeList {...props} />;
};

export default PageDefectTypeList;
